import { ForwardMailConfig } from './forward-mail.config';
import { ForwardMailListModule } from './old-design/list';
import { ForwardMailNewModule } from './old-design/new';
import { ForwardMailEditModule } from './old-design/edit';
import { ForwardMailMilitaryModule } from './old-design/military';
import { ForwardMailPromotionsModule } from './old-design/promotions/promotions.module';
import { ConfirmModule } from '../../common/directives';
import './new-design/progress-header';
import { OnModule } from '@updater-components/src/helpers/u-on';

export const ForwardMailStepModule = angular
  .module('app.steps.forward-mail', [
    ConfirmModule.name,
    ForwardMailListModule.name,
    ForwardMailNewModule.name,
    ForwardMailEditModule.name,
    ForwardMailMilitaryModule.name,
    ForwardMailPromotionsModule.name,
    OnModule.name,
  ])
  .config(ForwardMailConfig);
